import React from "react";

const Loader = () => {
  return (
    <>
      <svg
        className="up-logo-svg"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 518 249.3"
      >
        <g>
          <g>
            <path
              className="st0"
              d="M460.6,2.7c-30,0-54.4,24.4-54.4,54.4c0,10.9,3.3,21.1,8.8,29.6l-58.7,58.7c-8.5-5.6-18.7-8.8-29.6-8.8
			c-11.3,0-21.9,3.5-30.6,9.4l-59.3-59.3c5.6-8.5,8.8-18.7,8.8-29.6c0-30-24.4-54.4-54.4-54.4S136.9,27.1,136.9,57
			c0,10.9,3.3,21.1,8.8,29.6L87,145.4c-8.5-5.6-18.7-8.8-29.6-8.8C27.4,136.6,3,161,3,191s24.4,54.4,54.4,54.4s54.4-24.4,54.4-54.4
			c0-10.9-3.3-21.1-8.8-29.6l58.7-58.7c8.5,5.6,18.7,8.8,29.6,8.8c10.9,0,21.1-3.3,29.6-8.8l59.7,59.7c-5.2,8.3-8.2,18.2-8.2,28.7
			c0,30,24.4,54.4,54.4,54.4s54.4-24.4,54.4-54.4c0-10.9-3.3-21.1-8.8-29.6l58.7-58.7c8.5,5.6,18.7,8.8,29.6,8.8
			c30,0,54.4-24.4,54.4-54.4C515,27.1,490.6,2.7,460.6,2.7z M57.4,222.8c-17.6,0-31.9-14.3-31.9-31.9c0-17.6,14.3-31.9,31.9-31.9
			c17.6,0,31.9,14.3,31.9,31.9C89.3,208.5,74.9,222.8,57.4,222.8z M191.3,88.9c-17.6,0-31.9-14.3-31.9-31.9
			c0-17.6,14.3-31.9,31.9-31.9s31.9,14.3,31.9,31.9S208.9,88.9,191.3,88.9z M326.7,222.8c-17.6,0-31.9-14.3-31.9-31.9
			s14.3-31.9,31.9-31.9c17.6,0,31.9,14.3,31.9,31.9C358.6,208.5,344.3,222.8,326.7,222.8z M460.6,88.9c-17.6,0-31.9-14.3-31.9-31.9
			c0-17.6,14.3-31.9,31.9-31.9c17.6,0,31.9,14.3,31.9,31.9S478.2,88.9,460.6,88.9z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              className="st0"
              d="M182.8,144.7c-4.4-4.4-11.5-4.4-15.9,0L144,167.6c-4.4,4.4-4.4,11.5,0,15.9c2.2,2.2,5.1,3.3,7.9,3.3
			s5.8-1.1,7.9-3.3l22.9-22.9C187.2,156.2,187.2,149.1,182.8,144.7z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              className="st0"
              d="M380,72.9c-4.4-4.4-11.5-4.4-15.9,0l-22.9,22.9c-4.4,4.4-4.4,11.5,0,15.9c2.2,2.2,5.1,3.3,7.9,3.3
			c2.9,0,5.8-1.1,7.9-3.3L380,88.8C384.3,84.4,384.3,77.3,380,72.9z"
            />
          </g>
        </g>
      </svg>

      <div className="linear-activity">
        <div className="indeterminate" />
      </div>
    </>
  );
};

export default Loader;
